import { authHeader } from "@/_helpers/auth-header";
import { handleResponse } from "@/_helpers/handle-response";
import axios from "axios";

axios.defaults.baseURL = process.env.VUE_APP_API_ITTENTION;

export const imageService = {
  createImage,
  getImages,
  getImage,
  deleteMedia,
  updateMedia,
  updateMediaName,
  updateMediaProject
};

function createImage(data) {
  const requestOptions = {
    method: "post",
    url: "/projects/api/v1/media/",
    data: data,
    headers: {
      Authorization: authHeader().Authorization,
      "Content-Type": "multipart/form-data"
    },
    onUploadProgress: function (progressEvent) {
      
      this.uploadPercentage = parseInt(
        Math.round((progressEvent.loaded * 100) / progressEvent.total)
      );
    }.bind(this)
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

function getImages(limit = 1000, offset = 0) {
  const requestOptions = {
    method: "get",
    url: "/projects/api/v1/media/",
    params: {
      limit: limit,
      offset: offset
    },
    headers: authHeader()
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

function getImage(uuid) {
  const requestOptions = {
    method: "get",
    url: "/projects/api/v1/media/" + uuid,
    headers: authHeader()
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

function deleteMedia(uuid) {
  const requestOptions = {
    method: "delete",
    url: "/projects/api/v1/media/" + uuid,
    headers: authHeader()
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

const toDataURL = url => fetch(url, {
  method: "get",
  headers: authHeader(),
  mode: "cors",
  cache: "default"
})
  .then(response => response.blob())
  .then(blob => new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.onloadend = () => resolve(reader.result)
    reader.onerror = reject
    reader.readAsDataURL(blob)
  }))


function updateMedia(data) {
  let formData = new FormData()
  formData.append("project", data.project);
  const requestOptions = {
    method: "patch",
    url: "/projects/api/v1/media/" + data.uuid + "/",
    data: formData,
    headers: {
      Authorization: authHeader().Authorization,
      "Content-Type": "multipart/form-data",
    },
  };

  return axios(requestOptions)
    .then(handleResponse)
    .catch(error => {
      
    });
}

function updateMediaName(uuid, newName) {
  const requestOptions = {
    method: "patch",
    url: "/projects/api/v1/media/" + uuid,
    data: {name:newName},
    headers: {
      Authorization: authHeader().Authorization,
    },
  };
  return axios(requestOptions)
    .then(handleResponse => {
    })
    .catch(error => {
    });
}
function updateMediaProject([uuid, newProject]) {
  const requestOptions = {
    method: "patch",
    url: "/projects/api/v1/media/" + uuid,
    data: {project: newProject},
    headers: {
      Authorization: authHeader().Authorization,
    },
  };
  return axios(requestOptions)
    .then(handleResponse => {
    })
    .catch(error => {
    });
}